import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { fetchSummary } from "@/lib/analytics";
import { useLang } from "@/lib/i18n";


export default function LiveStats() {
  const { t: tr } = useLang();
  const [t, setT] = useState(null);

  useEffect(() => {
    fetchSummary().then((s) => setT(s.totals)).catch(() => {});
  }, []);

  const items = t
    ? [
        [t.case_study_reads, "case-study reads"],
        [t.concierge_conversations, "concierge conversations"],
        [t.cv_downloads, "CV downloads"],
      ]
    : [];

  return (
    <section
      id="live-stats"
      data-testid="live-stats-strip"
      className="border-y border-[#2e333c] bg-[#14352a] text-[#faf8f5]"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-16 py-4 flex flex-wrap items-center gap-x-8 gap-y-3">
        <div className="flex items-center gap-2 font-mono-label text-[10px] text-[#faf8f5]/60">
          <span className="w-1.5 h-1.5 rounded-full bg-[#d9a92e] pulse-dot" />
          {tr("This portfolio measures itself · live")}
        </div>
        <div className="flex flex-wrap gap-x-6 gap-y-2">
          {items.map(([v, l]) => (
            <div key={l} data-testid={`live-stat-${l.replace(/\s+/g, "-")}`} className="flex items-baseline gap-2">
              <span className="font-display text-xl leading-none">{v}</span>
              <span className="font-mono-label text-[10px] text-[#faf8f5]/60">{tr(l)}</span>
            </div>
          ))}
          {!t && (
            <span className="font-mono-label text-[10px] text-[#faf8f5]/40">
              loading…
            </span>
          )}
        </div>
        <Link
          to="/analytics"
          data-testid="live-stats-link"
          className="ml-auto inline-flex items-center gap-1 font-mono-label text-[10px] text-[#9a7218] link-underline"
        >
          {tr("Open the dashboard")} <ArrowUpRight className="h-3 w-3" />
        </Link>
      </div>
    </section>
  );
}
